import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { tierForCount, TIERS } from "@/lib/tiers";
import { Crown } from "lucide-react";

const TIER_STYLES = {
  bronzo: "bg-[#C08554] text-white",
  argento: "bg-[#B8B8B8] text-[#121212]",
  oro: "bg-[#C7A34A] text-[#121212]",
  platino: "bg-[#0B192C] text-white",
};

export function Leaderboard() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api
      .get("/waitlist/leaderboard/top?limit=10")
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, []);

  if (items === null) return null;

  return (
    <section className="bg-white py-24 md:py-32 px-6 md:px-12 border-t border-[#E5E5E5]" data-testid="leaderboard-section">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 mb-14">
          <div>
            <div className="sc-overline mb-4 inline-flex items-center gap-2">
              <Crown size={13} strokeWidth={1.5} /> Founding Ambassador
            </div>
            <h2 className="font-display font-light text-3xl md:text-4xl" style={{ letterSpacing: "-0.02em" }}>
              I membri che stanno costruendo il club
            </h2>
          </div>
          <div className="text-[11px] tracking-[0.28em] uppercase text-neutral-500">
            Aggiornato in tempo reale
          </div>
        </div>

        {items.length === 0 ? (
          <div className="text-center py-16 text-sm text-neutral-400 tracking-wider">
            Sii il primo a invitare — apri la classifica.
          </div>
        ) : (
          <ol className="divide-y divide-[#E5E5E5]">
            {items.map((it, i) => {
              const t = tierForCount(it.referrals_count);
              return (
                <li
                  key={i}
                  data-testid={`leaderboard-row-${i}`}
                  className="flex items-center gap-4 md:gap-8 py-5"
                >
                  <div className="w-8 text-right font-display text-lg text-[#0B192C]">{i + 1}</div>
                  <div className="flex-1 min-w-0">
                    <div className="font-mono text-sm text-[#121212] truncate">
                      {it.email_masked}
                    </div>
                    <div className="text-[11px] tracking-[0.2em] uppercase text-neutral-500 mt-1">
                      Posizione #{it.position}
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-display text-xl text-[#121212]">
                      {it.referrals_count}
                    </div>
                    <div className="text-[10px] tracking-[0.2em] uppercase text-neutral-400">
                      inviti
                    </div>
                  </div>
                  <span
                    className={`text-[10px] tracking-[0.2em] uppercase px-3 py-1 ${TIER_STYLES[t.key]}`}
                  >
                    {t.name}
                  </span>
                </li>
              );
            })}
          </ol>
        )}

        <div className="mt-12 text-center text-[13px] text-neutral-500">
          Scala la classifica invitando amici — sblocca perks esclusivi a ogni tier.
        </div>
      </div>
    </section>
  );
}
